/**
 * App Specific Route Mapping
 *Like
 */
const nameMapping = {
  Settings: "Questions",
  Content: "Announcements"
};

/**
 * App Specific Configurations
 */
const config = {
  hasActiveEntry: true,
  extraColumnKeys: [],
  evaluation: true,
  wideLayout: true
};

import {
  countValidInputs,
  getMissingFields,
  getMaxScore
} from "@/helpers/displayConfig.js";

// Total number of fact sheet fields (9 fields total)
const MAX_SCORE = getMaxScore();

/**
 * Filters irrelevant entries (e.g. entries that don't have meaningful data) and evaluates them
 * @param {Array} entries - The entries to filter and evaluate
 * @returns {Array} - The filtered and evaluated entries
 */
function tableEntries(entries) {
  entries = entries.filter((entry) => {
    // ---- modify the following line to add custom filtering logic --------------------------------
    return !!entry.value.IslandId;
  });

  // ---- add additional evaluation here, if needed ----------------------------------------
  entries = evaluate(entries);

  return entries;
}

/**
 * Evaluates the entries for completeness
 * @param {Array} entries - The entries to evaluate
 * @returns {Array} - The entries with the completed property added, if applicable
 */
function evaluate2(entries) {
  entries = entries.map((entry) => {
    // ---- modify the following line to add custom completion evaluation logic --------------
    const reportDetails = entry.value?.ReportDetails || {};
    const count = countValidInputs(reportDetails);
    entry.completed = count === MAX_SCORE;
    return entry;
  });

  return entries;
}

/**
 * Scores the entries
 * @param {Array} entries - The entries to score
 * @returns {Array} - The entries with the score, maxScore, and percent properties added
 */
function evaluate(entries) {
  entries = entries.map((entry) => {
    // ---- modify the following lines to add custom scoring logic ---------------------------
    const reportDetails = entry.value?.ReportDetails || {};
    const count = countValidInputs(reportDetails);
    entry.score = count;
    const missingFields = getMissingFields(reportDetails);
    entry.value.missingFields =
      missingFields.length > 0 ? missingFields.join(",") : "None";
    entry.maxScore = MAX_SCORE;
    entry.percent = Math.round((entry.score / entry.maxScore) * 100);
    return entry;
  });

  return entries;
}

/**
 * Transforms an array of entry objects by mapping each entry to a new object
 * with specific properties: fullname, onid, value, and "Last Updated".
 *
 * @param {Array} entries - The array of entry objects to be transformed.
 * @param {string} entries[].fullname - The full name of the entry.
 * @param {string} entries[].onid - The ONID of the entry.
 * @param {any} entries[].value - The value associated with the entry.
 * @param {string} entries[].tsUpdatedLabel - The timestamp label of the last update.
 * @returns {Array} - A new array of objects with the properties: fullname, onid, value, and "Last Updated".
 */
function exportEntries(entries) {
  const mappedEntries = entries.map((entry) => {
    const reportDetails = entry.value?.ReportDetails || {};
    const count = countValidInputs(reportDetails);
    const missingFields = getMissingFields(reportDetails);
    // ---- modify this object to create a custom export format suited for the admin user's needs ----
    return {
      fullname: entry.fullname,
      onid: entry.onid,
      score: `${count} / ${MAX_SCORE}`,
      missingFields: missingFields.join(","),
      "Last Updated": entry.tsUpdatedLabel
    };
  });

  return mappedEntries;
}

export {
  nameMapping,
  config,
  exportEntries,
  tableEntries,
  evaluate,
  evaluate2
};
